
<mat-drawer-container [hasBackdrop]="true">
    <mat-drawer #sidenav [mode]="'over'">
        <app-insights-filter-sidebar
            [filterForm]="filterForm"
            (closeButtonClicked)="sidenav.close()"
            [statusList]="statusList"
            [userList]="userList$ | async"
            [timeFrameList]="timeFrameList"
            [formType]="formsList$ | async"
            [aircraftList]="aircraftList$ | async"
            [formList]="formList$ | async"
            [groupFilterOptions]="groupFilterOptions$ | async"></app-insights-filter-sidebar>
    </mat-drawer>
    <mat-drawer-content class="app-content listings">
        <app-insights-filter-topbar
            [filterForm]="filterForm"
            [currentFilters]="currentFilters"
            (filterButtonClicked)="sidenav.open()"
            [statusList]="statusList"
            [userList]="userList$ | async"
            [timeFrameList]="timeFrameList"
            [formType]="formsList$ | async"
            [aircraftList]="aircraftList$ | async"
            [formList]="formList$ | async"
            [groupFilterOptions]="groupFilterOptions$ | async"></app-insights-filter-topbar>

        <app-loading-indicator
            *ngIf="!(stats$ | async); else content"></app-loading-indicator>

        <ng-template #content>
            <div *ngIf="!(stats$ | async)?.meta?.results; else stats">
                <app-empty-state
                    illustration="search"
                    title="No Statistics Yet"
                    message="There is no data in the selected date range and filters.">
                    <a
                        class="btn-secondary"
                        (click)="sidenav.open(); $event.stopPropagation()">
                        Edit Filters
                    </a>
                </app-empty-state>
            </div>

            <ng-template #stats>
                <!-- just one form -->
                <app-form-type-stats
                    *ngIf="statsData$ | async as stats"
                    [stats]="stats"
                    [formType]="filterForm.controls.formType.value">
                </app-form-type-stats>

                <!-- for múltiples forms -->
                <ng-container *ngIf="multipleStatsData$ | async as multiStats">
                    <ng-container *ngFor="let entry of multiStats">
                        <h3 class="text-xl font-semibold">
                            {{ getAssessmentTitle(entry.assessmentId) }}
                            <span class="view-more"
                            (click)="filterByAssessmentId(entry.assessmentId)"
                            >View More ></span>
                        </h3>

                        <form-type-row-stats
                            *ngIf="entry?.summary"
                            [assessmentId]="entry.assessmentId"
                            [stats]="entry.summary">
                        </form-type-row-stats>
                    </ng-container>
                </ng-container>



            </ng-template>



            <div
                class="footer-links"
                *ngIf="(stats$ | async)?.meta?.results > 0 || (multipleStatsData$ | async)?.length > 0">
                <p>Looking for different statistics? Let us know!</p>
                <a
                    class="request"
                    target="_blank"
                    href="https://www.risesms.com/feature-request">
                    Request Specific Statistics
                </a>
            </div>
        </ng-template>

        <div class="right-corner-control blue" *appMobile>
            <a (click)="exportPDF()">
                <span>Export Insights</span>
            </a>
        </div>
    </mat-drawer-content>
</mat-drawer-container>

